import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/left_ico.jpg'


const _withScopeId = n => (_pushScopeId("data-v-4cf0b3fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import { ref } from "vue";
import type { FormInstance } from "vant";
import { Field, Row, Col, Popup, Picker, Form } from "vant";
import CustomField from "../../../components/checkstand/CustomField.vue";
import { month, year } from "@/assets/data/list";
import { getOrder } from "../../../tools/checkstand/checkstandOrder";
// import { getCardType } from '@/tools/validate'


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicInfo',
  setup(__props, { expose }) {

const { order, basicRules } = getOrder();

// const cardType = computed(() => getCardType(order.CardNo))
const monthVisible = ref(false);
const monthList = month;
function onConfirmMonth(value: string) {
  order.CardExpireMonth = value;
  monthVisible.value = false;
}
const yearVisible = ref(false);
const yearList = year;
function onConfirmYear(value: string) {
  order.CardExpireYear = value;
  yearVisible.value = false;
}
const form = ref<FormInstance>();
expose({
  form,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Form), {
    class: "basic-info",
    ref_key: "form",
    ref: form
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Row), {
        type: "flex",
        justify: "space-between",
        class: "h3"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Col), null, {
            default: _withCtx(() => [
              _createTextVNode("Card Number:")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(Field), {
        class: "field",
        modelValue: _unref(order).CardNo,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(order).CardNo) = $event)),
        rules: _unref(basicRules).CardNo,
        type: "digit",
        name: "CardNo",
        maxlength: "16"
      }, null, 8, ["modelValue", "rules"]),
      _createVNode(_unref(Row), {
        class: "h3",
        type: "flex",
        justify: "space-between"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Col), { span: "13" }, {
            default: _withCtx(() => [
              _createTextVNode("Expiration Date:")
            ]),
            _: 1
          }),
          _createVNode(_unref(Col), { span: "10" }, {
            default: _withCtx(() => [
              _createTextVNode("C V V:")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(Row), { class: "h3" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Col), { span: "13" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Row), {
                type: "flex",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Col), { span: "10" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomField, {
                        value: _unref(order).CardExpireMonth,
                        onCustomClick: _cache[1] || (_cache[1] = ($event: any) => (monthVisible.value = true)),
                        name: "CardExpireMonth"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Col), { span: "13" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomField, {
                        value: _unref(order).CardExpireYear,
                        onCustomClick: _cache[2] || (_cache[2] = ($event: any) => (yearVisible.value = true)),
                        name: "CardExpireYear"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(Popup), {
            show: monthVisible.value,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((monthVisible).value = $event)),
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Picker), {
                "show-toolbar": "",
                columns: _unref(monthList),
                onConfirm: onConfirmMonth,
                "confirm-button-text": "confirm",
                "cancel-button-text": "cancel",
                onCancel: _cache[3] || (_cache[3] = ($event: any) => (monthVisible.value = false))
              }, null, 8, ["columns"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_unref(Popup), {
            show: yearVisible.value,
            "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((yearVisible).value = $event)),
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Picker), {
                "show-toolbar": "",
                columns: _unref(yearList),
                onConfirm: onConfirmYear,
                "confirm-button-text": "confirm",
                "cancel-button-text": "cancel",
                onCancel: _cache[5] || (_cache[5] = ($event: any) => (yearVisible.value = false))
              }, null, 8, ["columns"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_unref(Col), { span: "10" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Row), {
                type: "flex",
                justify: "space-between"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Col), { span: "18" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Field), {
                        class: "field",
                        modelValue: _unref(order).Cvv2,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(order).Cvv2) = $event)),
                        type: "password",
                        rules: _unref(basicRules).Cvv2,
                        name: "Cvv2",
                        maxlength: "3"
                      }, null, 8, ["modelValue", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Col), {
                    span: "5",
                    class: "img"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(Row), { class: "h3" }, {
        default: _withCtx(() => [
          _createTextVNode("First Name:")
        ]),
        _: 1
      }),
      _createVNode(_unref(Field), {
        class: "field",
        modelValue: _unref(order).FirstName,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(order).FirstName) = $event)),
        rules: _unref(basicRules).FirstName,
        name: "FirstName"
      }, null, 8, ["modelValue", "rules"]),
      _createVNode(_unref(Row), { class: "h3" }, {
        default: _withCtx(() => [
          _createTextVNode("Last Name:")
        ]),
        _: 1
      }),
      _createVNode(_unref(Field), {
        class: "field",
        modelValue: _unref(order).LastName,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(order).LastName) = $event)),
        rules: _unref(basicRules).LastName,
        name: "LastName"
      }, null, 8, ["modelValue", "rules"])
    ]),
    _: 1
  }, 512))
}
}

})